import { ChargeWaiverEntity } from "domain/entity/ChargeWaiver/ChargeWaiverEntity";
import { ChargeWaiverSearchCriteria } from "domain/entity/ChargeWaiver/ChargeWaiverSearchCriteria";
import { ResponseEntity } from "domain/entity/Common/ResponseEntity";
import { axiosPostData } from "../axios/AxiosBasicImpl";
import chargeAxiosInstance from "../axios/chargeAxiosInstance";
import { ChargeWaiverRepository } from "./ChargeWaiverRepo";

export const ChargeWaiverRepoImpl = (): ChargeWaiverRepository => {
    const url = "/v1/chargeWaiver";

    const searchChargeWaiverData = async (searchCriteria: ChargeWaiverSearchCriteria): Promise<ChargeWaiverEntity[]> => {
        const newUrl = url + "/search";

        return axiosPostData(chargeAxiosInstance, `${newUrl}`, searchCriteria).then(res => {
            const data = res.data;
            return data;
        }).catch(err => {
            return [];
        });
    }

    const update = async (entity: ChargeWaiverEntity): Promise<any> => {
        const newUrl = url + "/update";

        return axiosPostData(chargeAxiosInstance, `${newUrl}`, entity).then(res => {
            const data = res.data;
            return data;
        }).catch(err => {
            return null;
        });
    }

    const bulkUpdate = async (entitys: ChargeWaiverEntity[]): Promise<ResponseEntity> => {
        const newUrl = url + "/bulkupdate";

        return axiosPostData(chargeAxiosInstance, `${newUrl}`, entitys).then(res => {
            return res;
        }).catch(err => {
            return [];
        });
    }

    const submit = async (idList: number[]): Promise<ResponseEntity> => {
        const newUrl = url + "/submit";

        return axiosPostData(chargeAxiosInstance, `${newUrl}`, idList).then(res => {
            return res;
        }).catch(err => {
            return [];
        });
    }


    const searchChargeWaiverApprovalData = async (searchCriteria: ChargeWaiverSearchCriteria): Promise<ChargeWaiverEntity[]> => {
        const newUrl = "/v1/chargeWaiverApproval/search";

        return axiosPostData(chargeAxiosInstance, `${newUrl}`, searchCriteria).then(res => {
            const data = res.data;
            return data;
        }).catch(err => {
            return [];
        });
    }

    const approve = async (idList: number[]): Promise<ResponseEntity> => {
        const newUrl = "/v1/chargeWaiverApproval/approve";

        return axiosPostData(chargeAxiosInstance, `${newUrl}`, idList).then(res => {
            return res;
        }).catch(err => {
            return [];
        });
    }

    const reject = async (criteria: { idList: number[], reason: string }): Promise<ResponseEntity> => {
        const newUrl = "/v1/chargeWaiverApproval/reject";

        return axiosPostData(chargeAxiosInstance, `${newUrl}`, criteria).then(res => {
            return res;
        }).catch(err => {
            return [];
        });
    }

    const reverse = async (criteria: { idList: number[], reason: string }): Promise<ResponseEntity> => {
        const newUrl = "/v1/chargeWaiverApproval/reverse";

        return axiosPostData(chargeAxiosInstance, `${newUrl}`, criteria).then(res => {
            return res;
        }).catch(err => {
            return [];
        });
    }

    return {
        searchChargeWaiverData: searchChargeWaiverData,
        update: update,
        bulkUpdate: bulkUpdate,
        submit: submit,
        searchChargeWaiverApprovalData: searchChargeWaiverApprovalData,
        approve: approve,
        reject: reject,
        reverse: reverse,
    }
}